import { PageHeader } from '@core/components/PageHeader';
import { SearchBar } from '@core/components/SearchBar';
import Tour from '@core/components/Tour';
import { useApiUtils } from '@core/util/apiUtils';
import { steps } from '@core/util/tourUtils.js';
import FusePageCarded from '@fuse/core/FusePageCarded';
import { Button, makeStyles } from '@material-ui/core';
import { usuarioApi } from 'app/services/api/usuarioApi';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext';
import { initializeReactGA } from 'app/utils/analyticsUtil';
import React, { useContext, useEffect, useState } from 'react';
import { FaTruck } from 'react-icons/fa';
import { useHistory } from 'react-router';
import FornecedorBuscaAvancadaModal from './components/modal/FornecedorBuscaAvancadaModal';
import ImportarFornecedorModal from './components/modal/ImportarFornecedorModal/ImportarFornecedorModal';
import FornecedorCadastro from './container/cadastro/FornecedorCadastro';
import FornecedorTable from './container/tabela/FornecedorTable';
import FornecedorVisualizar from './container/visualizar/FornecedorVisualizar';
import { FornecedorActions } from './store';
import { FornecedorProvider, useFornecedor } from './store/fornecedorContext';

const useStyles = makeStyles({
  searchBarContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    maxWidth: '512px',
  },
  link: {
    color: '#53c4e6',
    fontWeight: '600',
    textTransform: 'initial',
  },
});

const SearchHeader = () => {
  const styles = useStyles();
  const [, dispatch] = useFornecedor();

  const handleOpenBuscaAvancada = () => {
    dispatch(FornecedorActions.buscaAvancada());
  };

  return (
    <PageHeader title="Fornecedores" icon={<FaTruck />}>
      <div className={`${styles.searchBarContainer}`}>
        <div className="items-center w-full max-w-512 stepBarraPesquisa">
          <SearchBar
            onChange={(value) => {
              dispatch(FornecedorActions.setPesquisar(value));
            }}
          />
        </div>
        <div className="stepBuscaAvancada">
          <Button className={styles.link} onClick={handleOpenBuscaAvancada}>
            Busca avançada
          </Button>
        </div>
      </div>
    </PageHeader>
  );
};

const FornecedorContent = () => {
  const history = useHistory();
  const [state, dispatch] = useFornecedor();
  const apiUtils = useApiUtils(dispatch, Actions);

  const [run, setRun] = useState(false);
  const [tour, setTour] = useState(false);
  const [, setLoading] = useState(false);

  const [funcionalidadesTour, setFuncionalidadesTour] = useContext(GlobalContext).funcionalidadesTour;

  const onFetchData = (params) => {
    const funcionalidadeJaExistente = funcionalidadesTour?.some((e) => e === 'FORNECEDORES');
    if (!funcionalidadeJaExistente) {
      setRun(true);
      setTour(true);
      FornecedorActions.buscarTour(dispatch);
    } else {
      FornecedorActions.carregarRegistros(dispatch, params, state.filtroAvancado);
    }
  };

  useEffect(() => {
    initializeReactGA(history?.location?.pathname);
    if (!funcionalidadesTour) {
      setFuncionalidadesTour([]);
    }
    onFetchData({
      page: state?.requestParams?.page,
      q: state?.requestParams?.q,
      size: state?.requestParams?.size,
      sort: state?.requestParams?.sort,
    });
    // Efeito de montagem: incluir as dependências reexecutaria a carga inicial a cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const atualizarTour = async () => {
    try {
      setLoading(true);
      funcionalidadesTour.push('FORNECEDORES');
      await usuarioApi.updateTour(funcionalidadesTour);
      setRun(false);
      setTour(false);
      setFuncionalidadesTour(funcionalidadesTour);
      onFetchData({
        page: state?.requestParams?.page,
        q: state?.requestParams?.q,
        size: state?.requestParams?.size,
        sort: state?.requestParams?.sort,
      });
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FusePageCarded
      innerScroll
      header={<SearchHeader />}
      content={
        <>
          <Tour steps={steps} run={run} setRun={setRun} onFinish={() => atualizarTour()} disableScrolling={true} />
          <FornecedorTable onTour={tour} onFetchData={onFetchData} />
          <FornecedorCadastro />
          <FornecedorVisualizar />
          <FornecedorBuscaAvancadaModal />
          <ImportarFornecedorModal />
        </>
      }
    />
  );
};

const Fornecedor = () => {
  return (
    <FornecedorProvider>
      <FornecedorContent />
    </FornecedorProvider>
  );
};

export default Fornecedor;
